let winObj = typeof(window) === `undefined` ? null : window
export default winObj